"use strict";

exports.__esModule = true;
exports.hexColorMatcher = void 0;
exports.isHexString = isHexString;
exports.matchHexString = matchHexString;
exports.shortHexColorMatcher = void 0;

var _utils = require("./utils");

var hex = /[0-9a-fA-F]/.source;
var hexColorMatcher = new RegExp("#(" + hex + "{2})(" + hex + "{2})(" + hex + "{2})(" + hex + "{2})?");
exports.hexColorMatcher = hexColorMatcher;
var shortHexColorMatcher = new RegExp("#(" + hex + ")(" + hex + ")(" + hex + ")(" + hex + ")?");
exports.shortHexColorMatcher = shortHexColorMatcher;

function isHexString(colorString) {
  return (0, _utils.exact)(hexColorMatcher).test(colorString) || (0, _utils.exact)(shortHexColorMatcher).test(colorString);
}

function matchHexString(colorString) {
  var _a;

  var match = (_a = (0, _utils.exact)(hexColorMatcher).exec(colorString)) !== null && _a !== void 0 ? _a : (0, _utils.exact)(shortHexColorMatcher).exec(colorString);
  return match ? (0, _utils.extractValuesFromMatch)(match) : null;
}